/**
 * Router adapter for the fetch transport.
 *
 * Keeping this tiny adapter separate prevents the http -> router -> guard -> auth
 * -> http dependency cycle. The router registers itself during bootstrap.
 */
export interface NavigationAdapter {
  push: (path: string) => void | Promise<unknown>;
  currentPath: () => string;
}

let adapter: NavigationAdapter = {
  push: () => {},
  currentPath: () => (typeof location === "undefined" ? "/" : location.pathname),
};

export function registerNavigation(next: NavigationAdapter): void {
  adapter = next;
}

export const navigation = {
  push(path: string): void | Promise<unknown> {
    return adapter.push(path);
  },
  currentPath(): string {
    return adapter.currentPath();
  },
};
